/* istanbul ignore file */
// TODO: ^ ignore coverage on this file until we can have app test scaffolding ready
import React, { useEffect } from 'react'
import PropTypes, { arrayOf, shape } from 'prop-types'
import ShutterList from 'components/ShutterList'
import TieredInterventionCallout from 'components/TieredInterventionCallout'
import TieredInterventionsHeader from 'components/TieredInterventionsHeader'
import TieredInterventionUnitCard from 'components/TieredInterventionUnitCard'
import { PageWrapper } from 'components/ShutterList/component.styles'
import {
  StyledBackgroundImage,
  TieredInterventionShutterList,
} from './component.styles'

const TieredInterventionsUnitsPage = props => {
  const { content, handleTabChange, navigationEvent, match } = props || {}
  const { url: currentUrl, search } = match || {}
  const queryParamsString = search || ''
  const { unitTi = {} } = content || {}
  const {
    displayTitle: pageDisplayTitle,
    description: pageDescription,
    image: pageImage,
    tabSummaries,
    linkSummaries,
    smallGroupDataInstanceData,
  } = unitTi || {}

  let courseDisplayTitle = smallGroupDataInstanceData
    ? 'Grades k-2: ' + smallGroupDataInstanceData?.title
    : 'Grades k-2'
  let courseDescription = null

  let tabs = tabSummaries

  const hasFooter = !!pageImage

  const tabDescription = {
    body: pageDescription ?? 'fake page description',
    title: pageDisplayTitle ?? 'fake page title',
    hasFooter,
    footerChildren: hasFooter && <StyledBackgroundImage src={pageImage?.url} />,
  }

  // Function to generate progress text based on URL and smallGroupDataInstanceData
  const generateProgressText = () => {
    // Only show progress text if URL includes "tier-2/teach"
    if (!currentUrl.includes('tier-2/teach')) {
      return undefined
    }

    // Check if we have smallGroupDataInstanceData with smallGroups
    if (
      !smallGroupDataInstanceData?.smallGroups ||
      !Array.isArray(smallGroupDataInstanceData.smallGroups)
    ) {
      return undefined
    }

    // Count completed small groups
    const completedGroups = smallGroupDataInstanceData.smallGroups.filter(
      group => group.isComplete,
    )
    const totalGroups = smallGroupDataInstanceData.smallGroups.length

    if (totalGroups === 0) {
      return undefined
    }

    // Generate the progress text
    const lessonText = totalGroups === 1 ? 'Lesson' : 'Lessons'
    return `${completedGroups.length} ${lessonText} Complete`
  }

  const activeHeader = tabs?.find(t =>
    window.location.pathname.endsWith(t.route),
  )
    ? {
        id:
          tabs.find(t => window.location.pathname.endsWith(t.route))
            .internalTitle ||
          tabs.find(t => window.location.pathname.endsWith(t.route))
            .displayTitle,
        title: tabs.find(t => window.location.pathname.endsWith(t.route))
          .displayTitle,
        description: tabs.find(t => window.location.pathname.endsWith(t.route))
          .description,
      }
    : null

  const items =
    linkSummaries?.map(item => ({
      title: item?.displayTitle,
      description: item?.description,
      path: item?.route,
      isPreview: item?.isPreview,
      markedComplete: item?.markedComplete,
      tags: item.tags,
    })) || []

  const renderItem = item => (
    <TieredInterventionUnitCard
      description={item?.description}
      isPreviewMode={item?.isPreview}
      markedComplete={item?.markedComplete}
      path={`${currentUrl}/${item?.path}`}
      tags={item?.tags}
      title={item?.title}
    />
  )

  // Create tabs for the new header
  const headerTabs =
    tabs?.map(tab => ({
      title: tab?.displayTitle,
      isActive: activeHeader?.title === tab?.displayTitle,
      ...tab,
    })) || []

  const handleBackClick = () => {
    // Navigate back to lessons page
    const currentPath = window.location.pathname
    const basePath = currentPath.split('/tier-2')[0]
    navigationEvent(`${basePath}/lessons`)
  }

  const handleHeaderTabChange = tab => {
    const originalTab = tabs?.find(t => t?.displayTitle === tab?.title)
    handleTabChange(originalTab)
  }

  // Page-level logic
  const pageTitles = {
    page: 'Tiered Interventions',
    category: activeHeader?.title,
  }

  useEffect(() => {
    if (pageTitles.category) {
      document.title = `${pageTitles.page} | ${pageTitles.category}`
    }
  }, [pageTitles.category])

  return (
    <PageWrapper>
      <TieredInterventionsHeader
        backLinkOnClick={handleBackClick}
        backLinkText="Elementary School Lessons"
        description={courseDescription}
        onTabChange={handleHeaderTabChange}
        progressText={generateProgressText()}
        siteName="Forest Ridge Elementary"
        tabs={headerTabs}
        tierLabel="TIER 2"
        title={courseDisplayTitle}
      />
      <TieredInterventionShutterList>
        <ShutterList
          className="tiered-intervention-shutter-list"
          contentDescription={tabDescription}
          items={items}
          queryParams={queryParamsString}
          renderContentDescription={contentDescription => (
            <TieredInterventionCallout
              contentDescription={contentDescription}
            />
          )}
          renderItem={renderItem}
        />
      </TieredInterventionShutterList>
    </PageWrapper>
  )
}

const summary = shape({
  description: PropTypes.string.isRequired,
  displayTitle: PropTypes.string.isRequired,
  internalTitle: PropTypes.string,
  route: PropTypes.string,
  isPreview: PropTypes.bool,
  markedComplete: PropTypes.bool,
  tags: PropTypes.arrayOf(PropTypes.string),
  image: shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
})

TieredInterventionsUnitsPage.propTypes = {
  content: PropTypes.shape({
    unitTi: shape({
      displayTitle: PropTypes.string,
      description: PropTypes.string,
      image: shape({
        title: PropTypes.string,
        url: PropTypes.string,
      }),
      tabSummaries: arrayOf(summary),
      linkSummaries: arrayOf(summary),
      smallGroupDataInstanceData: shape({
        title: PropTypes.string,
        smallGroups: arrayOf(
          shape({
            isComplete: PropTypes.bool,
          }),
        ),
      }),
    }),
  }),
  handleTabChange: PropTypes.func,
  match: PropTypes.shape({
    url: PropTypes.string,
    search: PropTypes.string,
    params: PropTypes.object,
  }),
  navigationEvent: PropTypes.func,
}

export default TieredInterventionsUnitsPage
